import Coverage from 'pages/benefits/coverage/Coverage';
import { CoveragePlan } from 'all-in-one-shared-api';

function WorldwideEmergencyAssistance() {
  return <Coverage coveragePlan={CoveragePlan.EMERGENCY_ASSISTANCE} />;
}

export default WorldwideEmergencyAssistance;
